import React, { useState } from 'react'
import { Input, Button, Modal } from 'semantic-ui-react'
import { PatternFormat } from 'react-number-format'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import 'moment/locale/pt-br'

import { ModalContentWrapper } from './styles'

interface OnChangeData {
  value: string
}

interface DateTimeInputProps {
  id?: string
  name?: string
  value: string
  readOnly?: boolean
  disabled?: boolean
  fluid?: boolean
  minDate?: Date
  maxDate?: Date
  onChange?: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.SyntheticEvent<HTMLElement, Event>,
    data: OnChangeData
  ) => void
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  id,
  name,
  value,
  readOnly,
  disabled,
  fluid,
  minDate,
  maxDate,
  onChange
}) => {
  const [modal, setModal] = useState(false)

  function handleModalClose() {
    setModal(false)
  }

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(event, { value: event.target.value })
  }

  function handlePickerChange(date: Date | null) {
    const formattedDate = date ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    onChange?.({} as React.SyntheticEvent<HTMLElement, Event>, {
      value: formattedDate
    })
    setModal(false)
  }

  const selectedDate = value ? moment(value, 'DD/MM/YYYY HH:mm').toDate() : null

  return (
    <>
      <Input id={id} fluid={fluid}>
        <PatternFormat
          id={id}
          name={name}
          format="##/##/#### ##:##"
          value={value}
          onChange={handleChange}
          readOnly={readOnly}
          disabled={disabled}
        />
        <Button
          icon="calendar"
          type="button"
          onClick={() => setModal(true)}
          disabled={readOnly || disabled}
          basic
        />
      </Input>
      <Modal open={modal} onClose={handleModalClose} size="tiny" basic>
        <Modal.Content>
          <ModalContentWrapper>
            <DatePicker
              selected={selectedDate}
              onChange={handlePickerChange}
              dateFormat="dd/MM/yyyy HH:mm"
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Time"
              minDate={minDate}
              maxDate={maxDate ? new Date(maxDate) : undefined}
              inline
              locale="pt-br"
            />
          </ModalContentWrapper>
        </Modal.Content>
      </Modal>
    </>
  )
}
